import React from 'react'

function Banner() {
  return (
    <div className='cv_banner'>
            <h2>Contact-<span>Us</span></h2>
           <p> Reach out to us for any questions, feedback, or support. Our team is<br/> here to help you every step of the way.</p>
    </div>
  )
}

export default Banner